module.exports = __webpack_public_path__ + "static/media/ki.cdeef8df.svg";